import Cookies from 'universal-cookie';
import { useNavigate } from "react-router-dom";
import React, {useState} from "react";
import { sendLogoutUserRequest } from "../../../helpers/api-requests/auth";
import {Alert, Button} from "react-daisyui";
import Spinner from "../../partials/Spinner";
import * as Icon from "react-bootstrap-icons";

export default function LogoutUser() {
    const [errors, setErrors] = useState('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState('');

    const tryLogoutUser = async e => {
        e.preventDefault();

        const response = await sendLogoutUserRequest(null, () => {
            setLoading(true);
        },() => {
            setLoading(false);
        });

        setErrors({...response});

        if(response.status === 200 || response.status === 401) {
            new Cookies().remove('session');

            navigate("/login", {
                replace: true,
            });
        }
    }

    return (
        <>
            <a onClick={tryLogoutUser} className={'cursor-pointer'}>
                <Icon.BoxArrowLeft className={'icon'} size={18}/>
                { loading ? <Spinner/> : <span className="text">Wyloguj</span> }
            </a>

            {
                (errors && (errors.status === undefined || (errors.status !== 400))) && <Alert className={'text-sm py-2 px-4 mt-2 rounded-lg'} status={'error'}>{ errors.message }</Alert>
            }
        </>
    );
}